import React, { useContext } from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';

import { AuthContext } from '../../../context/auth';

function PrivateRoute({ component: Component, ...rest }) {
  const { pathname } = useLocation();
  const program = pathname.substring(1).split('/')[0];
  const { user } = useContext(AuthContext);

  // Next line is temporal...
  if (pathname === '/dsp/sandbox') return <Redirect to={`/${user?.slug}`} />;

  return (
    <Route
      {...rest}
      render={(props) =>
        user && program === user.slug ? (
          <Component {...props} />
        ) : (
          <Redirect to={`/${user?.slug || program}`} />
        )
      }
    />
  );
}

export default PrivateRoute;
